import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useId, useMemo, useRef, useState } from 'react';
import cn from 'clsx';
import { defaultProps } from "./constants";
import useRealShape from "./hooks/useRealShape";
import { jsx as _jsx } from "react/jsx-runtime";
export var Collapse = function Collapse(_ref) {
  var _ref$open = _ref.open,
    open = _ref$open === void 0 ? defaultProps.open : _ref$open,
    _ref$delay = _ref.delay,
    delayProp = _ref$delay === void 0 ? defaultProps.delay : _ref$delay,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? defaultProps.animated : _ref$animated,
    styleProp = _ref.style,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    notAssignHeight = _ref.notAssignHeight,
    children = _ref.children;
  var id = useId();
  var ref = useRef(null);
  var _useState = useState(open ? 'auto' : '0'),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(open),
    _useState4 = _slicedToArray(_useState3, 2),
    selfExpanded = _useState4[0],
    setSelfExpanded = _useState4[1];
  var contentRef = useRef(null);
  var entryTimer = useRef();
  var leaveTimer = useRef();
  var resetTimer = useRef();
  var _useState5 = useState(delayProp),
    _useState6 = _slicedToArray(_useState5, 2),
    delay = _useState6[0],
    setDelay = _useState6[1];
  var _useRealShape = useRealShape(contentRef),
    _useRealShape2 = _slicedToArray(_useRealShape, 2),
    state = _useRealShape2[0],
    updateShape = _useRealShape2[1];
  useEffect(function () {
    if (notAssignHeight) {
      setHeight('auto');
    } else {
      setHeight("".concat(state.height, "px")), [state.height];
    }
  });
  useEffect(function () {
    setDelay(animated ? delayProp : 0);
  }, [animated, delayProp]);
  useEffect(function () {
    var closeAnimationRef;
    var openAnimationRef;
    if (open === selfExpanded) return;

    // show element or reset height.
    // force an update once manually, even if the element does not change.
    // (the height of the element might be "auto")
    if (!open) {
      updateShape();
      closeAnimationRef = requestAnimationFrame(function () {
        setHeight("".concat(state.height, "px"));
      });
    }

    // show expand animation
    entryTimer.current = window.setTimeout(function () {
      setSelfExpanded(open);
      clearTimeout(entryTimer.current);
    }, 30);

    // Reset height after animation
    if (open) {
      resetTimer.current = window.setTimeout(function () {
        openAnimationRef = requestAnimationFrame(function () {
          setHeight('auto');
          clearTimeout(resetTimer.current);
        });
      }, delay);
    } else {
      leaveTimer.current = window.setTimeout(function () {
        clearTimeout(leaveTimer.current);
      }, delay / 2);
    }
    return function () {
      clearTimeout(entryTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(resetTimer.current);
      [closeAnimationRef, openAnimationRef].forEach(function (ref_) {
        return typeof ref_ === 'number' && cancelAnimationFrame(ref_);
      });
    };
  }, [open, animated]);
  var style = useMemo(function () {
    var getHeight = function getHeight() {
      if (!animated) {
        return open ? undefined : '0';
      }
      return selfExpanded ? height : '0';
    };
    return _objectSpread(_objectSpread({}, styleProp), {}, {
      height: getHeight()
    });
  }, [animated, height, open, selfExpanded, styleProp]);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    style: style,
    "data-testid": dataTestId,
    className: cn('tw-p-0 tw-m-0 tw-overflow-hidden', _defineProperty(_defineProperty(_defineProperty({
      'tw-transition-all': animated
    }, "tw-duration-".concat(delay), animated && delay > 0), 'tw-opacity-100', selfExpanded && animated), 'tw-opacity-0', !selfExpanded && animated), className),
    children: /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: "compass-collapse-content-".concat(id),
      children: children
    })
  });
};
export default Collapse;